export class StringUtil {
  static capitalizeFirstLetter(str: string): string {
    if(str == null || str.trim() === ""){
      return "";
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
